<template>
  <v-flex xs12>
    <v-card>
      <v-layout row align-center justify-center class="arrow-up py-2" @click="$emit('prev')">
        <v-icon>keyboard_arrow_up</v-icon>
      </v-layout>
      <v-flex xs12 v-if="err">
        <v-alert type="error" :value="true">{{err}}</v-alert>
      </v-flex>
      <v-layout row wrap align-start class="px-2">
        <v-flex xs12 sm6 px-3 pb-1>
          <p>{{$lang.labels.created}}: <span class="mx-2">{{ formatDate(config.createdOn) }}</span></p>
        </v-flex>
        <v-flex xs12 sm6 px-3 pb-1>
          <p>{{$lang.header.synched}}:
            <span class="mx-2" v-if="config.synchedOn">{{ formatDate(config.synchedOn) }}</span>
            <span class="mx-2 no-data" v-else>{{$lang.errors.noData}}</span>
          </p>
        </v-flex>
        <v-flex xs12 sm6 px-3 pb-1>
          <p>{{$lang.labels.companyName}}: <span class="mx-2">{{config.companyName}}</span></p>
        </v-flex>
        <v-flex xs12 sm6 px-3 pb-1 v-if="config.refreshCorporation">
          <p>{{$lang.labels.corporation}}: <span class="mx-2">{{config.refreshCorporation}}</span></p>
        </v-flex>
        <v-flex xs12 sm6 px-3 pb-1 v-if="this.type === 'moon'">
          <p>{{$lang.header.moonInstName}}: <span class="mx-2">{{config.moonInsatanceName}}</span></p>
        </v-flex>
        <v-flex xs12 sm6 px-3 pb-1 v-if="this.type === 'planet'">
          <p>{{$lang.labels.planetInstName}}: <span class="mx-2">{{config.planetInstanceName}}</span></p>
        </v-flex>
        <v-flex xs12 sm6 px-3 pb-1 v-if="config.status">
          <p>{{$lang.labels.status}}: <span class="mx-2">{{config.status}}</span></p>
        </v-flex>
        <v-flex xs12 sm6 px-3 pb-1>
          <p>{{$lang.labels.companyDataUpdated}}:
            <span class="mx-2" v-if="config.refreshCompanyData">{{ config.refreshCompanyData === true ? 'Yes' : 'No' }}</span>
            <span class="mx-2 no-data" v-else>{{$lang.errors.noData}}</span>
          </p>
        </v-flex>
        <v-flex xs12 sm6 px-3 pb-1>
          <p>{{$lang.header.accounts}}:
            <ul v-if="config.refreshAccounts">
              <li v-for="(account, index) in config.refreshAccounts" :key="index">{{account}}</li>
            </ul>
            <span class="mx-2 no-data" v-else>{{$lang.errors.noData}}</span>
          </p>
        </v-flex>
        <v-flex xs12 sm6 px-3 pb-1>
          <p>{{$lang.header.printers}}:
            <ul v-if="config.refreshPrinters">
              <li v-for="(printer, index) in config.refreshPrinters" :key="index">{{printer}}</li>
            </ul>
            <span class="mx-2 no-data" v-else>{{$lang.errors.noData}}</span>
          </p>
        </v-flex>
        <v-flex xs12 sm6 px-3 pb-1>
          <p>{{$lang.header.printTemplates}}:
            <ul v-if="config.refreshPrintTemplates">
              <li v-for="(template, index) in config.refreshPrintTemplates" :key="index">{{template}}</li>
            </ul>
            <span class="mx-2 no-data" v-else>{{$lang.errors.noData}}</span>
          </p>
        </v-flex>
        <v-flex xs12 sm6 px-3 pb-1>
          <p>{{$lang.header.printServers}}:
            <ul v-if="config.refreshPrintServers">
              <li v-for="(server, index) in config.refreshPrintServers" :key="index">{{server}}</li>
            </ul>
            <span class="mx-2 no-data" v-else>{{$lang.errors.noData}}</span>
          </p>
        </v-flex>
        <v-flex xs12 sm6 px-3 pb-1>
          <p>{{$lang.header.catalogs}}:
            <ul v-if="config.refreshCatalogs">
              <li v-for="(catalog, index) in config.refreshCatalogs" :key="index">{{catalog}}</li>
            </ul>
            <ul v-else-if="config.refreshCatalogData">
              <li v-for="(catalog, index) in config.refreshCatalogData" :key="index">{{catalog}}</li>
            </ul>
            <span class="mx-2 no-data" v-else>{{$lang.errors.noData}}</span>
          </p>
        </v-flex>
        <v-flex xs12 sm6 px-3 pb-1 v-if="config.tables">
          <p>{{$lang.header.tables}}:
            <ul v-if="config.tables">
              <li v-for="(tables, index) in config.tables" :key="index">{{tables}}</li>
            </ul>
            <span class="mx-2 no-data" v-else>{{$lang.errors.noData}}</span>
          </p>
        </v-flex>
        <v-flex xs12 sm6 px-3 pb-1 v-if="config.tableCategories">
          <p>{{$lang.header.tableCategories}}:
            <ul v-if="config.tableCategories">
              <li v-for="(tableCat, index) in config.tableCategories" :key="index">{{tableCat}}</li>
            </ul>
            <span class="mx-2 no-data" v-else>{{$lang.errors.noData}}</span>
          </p>
        </v-flex>
        <v-flex xs12 sm6 px-3 pb-1 v-if="config.refreshTables">
          <p>{{$lang.header.tables}}:
          <ul v-if="config.refreshTables">
            <li v-for="(tables, index) in config.refreshTables" :key="index">{{tables}}</li>
          </ul>
          <span class="mx-2 no-data" v-else>{{$lang.errors.noData}}</span>
          </p>
        </v-flex>
        <v-flex xs12 sm6 px-3 pb-1 v-if="config.refreshTableCategories">
          <p>{{$lang.header.tableCategories}}:
          <ul v-if="config.refreshTableCategories">
            <li v-for="(tableCat, index) in config.refreshTableCategories" :key="index">{{tableCat}}</li>
          </ul>
          <span class="mx-2 no-data" v-else>{{$lang.errors.noData}}</span>
          </p>
        </v-flex>
        <v-flex xs12 sm6 px-3 pb-1>
          <p>{{$lang.header.callerIdServers}}:
            <ul v-if="config.refreshCallerIdServers">
              <li v-for="(callerID, index) in config.refreshCallerIdServers" :key="index">{{callerID}}</li>
            </ul>
            <span class="mx-2 no-data" v-else>{{$lang.errors.noData}}</span>
          </p>
        </v-flex>
        <v-flex xs12 sm6 px-3 pb-1>
          <p>{{$lang.header.webShopResource}}:
            <ul v-if="config.refreshWebShopResourceNames">
              <li v-for="(tableCat, index) in config.refreshWebShopResourceNames" :key="index">{{tableCat}}</li>
            </ul>
            <span class="mx-2 no-data" v-else>{{$lang.errors.noData}}</span>
          </p>
        </v-flex>
         <v-flex xs12 sm6 px-3 pb-1>
          <p>{{$lang.labels.langMapforPrintCat}}:
            <br>
            <span class="mx-2" v-if="config.refreshPrinterCategoryLanguageMappings">{{ config.refreshPrinterCategoryLanguageMappings === true ? 'Yes' : 'No' }}</span>
            <span class="mx-2 no-data" v-else>{{$lang.errors.noData}}</span>
          </p>
        </v-flex>
        <v-flex xs12 sm6 px-3 pb-1>
          <p>{{$lang.labels.discountRules}}:
            <span class="mx-2" v-if="config.refreshDiscountRules">{{ config.refreshDiscountRules === true ? 'Yes' : 'No' }}</span>
            <span class="mx-2 no-data" v-else>{{$lang.errors.noData}}</span>
          </p>
        </v-flex>
        <v-flex xs12 sm6 px-3 pb-1>
          <p>{{$lang.labels.discountRuleNames}}:
            <template v-if="config.refreshDiscountRuleNames">
              <ul v-for="(ruleName, index) in config.refreshDiscountRuleNames" :key="index">
                <li>{{ruleName}}</li>
              </ul>
            </template>
            <span class="mx-2 no-data" v-else>{{$lang.errors.noData}}</span>
          </p>
        </v-flex>
        <v-flex xs12 sm6 px-3 pb-1>
          <p>{{$lang.labels.depReceipts}}:
            <template v-if="config.depReceipts">
              <ul v-for="(dep, index) in config.depReceipts" :key="index">
                <li>{{dep}}</li>
              </ul>
            </template>
            <span class="mx-2 no-data" v-else>{{$lang.errors.noData}}</span>
          </p>
        </v-flex>
        <v-flex xs12 sm6 px-3 pb-1>
          <p>{{$lang.labels.paymentTerminals}}:
            <template v-if="config.refreshPaymentTerminals">
              <ul v-for="(terminal, index) in config.refreshPaymentTerminals" :key="index">
                <li>{{terminal}}</li>
              </ul>
            </template>
            <span class="mx-2 no-data" v-else>{{$lang.errors.noData}}</span>
          </p>
        </v-flex>
        <v-flex xs12 sm6 px-3 pb-1>
          <p>{{$lang.labels.paymentServers}}:
            <template v-if="config.refreshPaymentServers">
              <ul v-for="(server, index) in config.refreshPaymentServers" :key="index">
                <li>{{server}}</li>
              </ul>
            </template>
            <span class="mx-2 no-data" v-else>{{$lang.errors.noData}}</span>
          </p>
        </v-flex>
      </v-layout>
      <v-btn fab small flat class="close-btn" absolute @click="$emit('close')"><v-icon>close</v-icon></v-btn>
      <v-layout row align-center justify-center class="arrow-down py-2" @click="$emit('next')">
        <v-icon>keyboard_arrow_down</v-icon>
      </v-layout>
    </v-card>
  </v-flex>
</template>

<script>
  import {DateTime} from 'luxon';

  export default {
    props: ['id', 'type'],
    data () {
      return {
        err: '',
        config: {},
      };
    },
    watch: {
      id() {
        this.fetchConfigData();
      }
    },
    methods: {
      formatDate(date) {
        return DateTime.fromISO(date).toFormat('yyyy-MM-dd HH:mm');
      },
      fetchConfigData() {
        const url = `${this.type}/configupdates/${this.id}`;
        this.$http.get(url)
          .then((res) => {
            if (res.body.status === 'Success') {
              this.config = res.body.config;
              return;
            }
            this.err = res.body.statusText;
          }, (err) => {
            this.err = err.body.statusText || err.body.message;
          });
      },
    },
    created() {
      this.fetchConfigData();
    },
  };
</script>

<style lang="scss" scoped>
.close-btn {
    right: 8px;
    top: 8px;
  }
  p {
    font-size: 16px;
    color: #FFB300;
    span {
      color: rgba(#000, .75);
    }
  }
  ul {
    padding-left: 18px;
    color: rgba(#000, .75);
  }
  .no-data {
    color: rgba(#000, .57);
  }
  .arrow-down,
  .arrow-up {
    cursor: pointer;
    i {
      font-size: 50px !important;
      color: rgba(#000, .75) !important;
    }
  }
</style>



// WEBPACK FOOTER //
// ConfigUpdateView.vue?81badd04